// src/store/prescriptionsSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PrescriptionType } from "../../interface/GeneralResponse";

interface PrescriptionsState {
  prescriptions: PrescriptionType[];
  selectedTemplate: PrescriptionType | null;
}

const initialState: PrescriptionsState = {
  prescriptions: [] as PrescriptionType[],
  selectedTemplate: null,
};

const prescriptionsSlice = createSlice({
  name: "prescriptions",
  initialState,
  reducers: {
    setPrescriptions(state, action: PayloadAction<PrescriptionType[]>) {
      state.prescriptions = action.payload;
    },
    clearPrescriptions(state) {
      state.prescriptions = [];
    },
    removePrescription(state, action: PayloadAction<number>) {
      state.prescriptions = state.prescriptions.filter(
        (prescription) => prescription.Id !== action.payload,
      );
    },
    updatePrescription(state, action: PayloadAction<PrescriptionType>) {
      const index = state.prescriptions.findIndex(
        (prescription) => prescription.Id === action.payload.Id,
      );
      if (index !== -1) {
        state.prescriptions[index] = action.payload;
      }
    },
  },
});

export const {
  setPrescriptions,
  clearPrescriptions,
  removePrescription,
  updatePrescription,
} = prescriptionsSlice.actions;

export default prescriptionsSlice.reducer;
